import { Video } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-wrapping-tutorial.png";
import placeholder from "@/assets/holiday-cards/Reusable-Gift-Wrapping-Video-Cover.jpg";
import { DayDefinition } from "../DayDefinition.js";

/**
 * Class Wrapping_Tutorial
 *
 * Represents the Wrapping Tutorial card.
 */
export class Wrapping_Tutorial extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-red2022";

	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "wrapping-tutorial";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Reusable Present Wrapping Tutorial";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`This is Furoshiki, a Japanese gift-wrapping technique
					To give your gifts a special touch that everyone will think is unique
					Go for cloth or linen this year, wrapping paper is so 2021
					Late-night gift wrapping just got a whole lot more fun`}
				</p>
				<Video
					image={placeholder}
					title="Reusable present wrapping
				tutorial"
					video="MrIeSahFAaY"
				/>
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Tutoriel - Recyclez vos emballages cadeaux !";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Voici le Furoshiki, une technique japonaise pour emballer vos cadeaux,
					C’est une manière originale de customiser la déco.
					Cette année, le papier-cadeau n’est plus vraiment à la mode
					Alors préférez le tissu ou le lin comme méthode`}
				</p>
				<p className="hl:whitespace-pre-line">{`*En anglais uniquement.`}</p>
				<Video
					image={placeholder}
					title="Reusable present wrapping
				tutorial"
					video="MrIeSahFAaY"
				/>
			</>
		);
	}
}
